import React, { useState, useCallback } from 'react';
import './HtmlEditor.css';

const DEFAULT_HTML = `<h1>Hello, World!</h1>
<p>这是一个 <strong>HTML 渲染</strong> 示例。</p>
<ul>
  <li>在左侧输入 HTML</li>
  <li>右侧实时预览效果</li>
</ul>`;

const HtmlEditor = () => {
  const [html, setHtml] = useState(DEFAULT_HTML);

  const handleChange = useCallback((e) => {
    setHtml(e.target.value);
  }, []);

  const handleClear = useCallback(() => {
    setHtml('');
  }, []);

  const handleReset = useCallback(() => {
    setHtml(DEFAULT_HTML);
  }, []);

  return (
    <div className="html-editor-page">
      <header className="html-editor-header">
        <h1>税务爬虫项目HTML实时预览</h1>
        <div className="header-actions">
          <button className="btn btn-secondary" onClick={handleClear}>清空</button>
          <button className="btn btn-secondary" onClick={handleReset}>重置示例</button>
        </div>
      </header>

      <div className="html-editor-body">
        {/* 左侧输入区 */}
        <div className="editor-panel">
          <div className="panel-header">
            <span className="panel-title">HTML 输入</span>
            <span className="char-count">{html.length} 字符</span>
          </div>
          <textarea
            className="html-textarea"
            value={html}
            onChange={handleChange}
            placeholder="在此输入 HTML 代码..."
            spellCheck={false}
          />
        </div>

        {/* 分隔线 */}
        <div className="divider" />

        {/* 右侧预览区 */}
        <div className="preview-panel">
          <div className="panel-header">
            <span className="panel-title">渲染预览</span>
          </div>
          <div
            className="html-preview"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      </div>
    </div>
  );
};

export default HtmlEditor;
